<template>
  <v-badge :bordered="bordered"
           :bottom="bottom"
           :color="color"
           :disabled="disabled"
           :icon="icon"
           :left="left"
           :offset-x="offsetX"
           :offset-y="offsetY"
           v-bind="$attrs"
           v-on="$attrs"
  >
    <!-- @slot used for the badge’s content -->
    <slot name="badge"></slot>
    <!-- @slot used for the element the badge hovers on -->
    <slot></slot>
  </v-badge>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  type AppIconBadgePosition = 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'

  defineOptions({
    inheritAttrs: false,
  })

  const props = withDefaults(defineProps<{
    // If true, add border on badge
    bordered?: boolean
    // Color of badge
    color?: string
    // If true, don't display badge
    disabled?: boolean
    // Icon to display inside the badge
    icon?: string
    // Position of badge | Possible values: bottom-left, bottom-right, top-left, top-right
    position?: AppIconBadgePosition
    // Offset the badge on the x axis
    offsetX?: number | string
    // Offset the badge on the y axis
    offsetY?: number | string
    // If true, overlap badge on top of the slotted content
    overlap?: boolean
  }>(), {
    bordered: true,
    color: 'primary',
    disabled: false,
    icon: undefined,
    position: 'top-left',
    offsetX: 0,
    offsetY: 0,
    overlap: true,
  })

  const bottom = computed(() => props.position?.includes('bottom') ?? false)
  const left = computed(() => props.position?.includes('left') ?? false)
</script>

<style scoped lang="scss">
:deep(.v-badge__badge) {
  margin: 2px; // to avoid too much overlapping on "paddingless" & small elements

  & .v-icon {
    font-size: 0.7rem;
    color: white !important;
  }
}
</style>
